import React from 'react';
import {
  Portal,
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Link from '../Link';
import { getWhatsappLink } from '../../utils/utils';
import styles from './styles.module.scss';

const BtnFlotanteWhatsapp = () => {

  return (<>
    {(typeof document !== "undefined") && <>
      <Portal container={document.getElementById("portal")}>
        <Link href={getWhatsappLink()} external={true} aria-label="Escribinos por WhatsApp">
          <div className={styles.boton}>
            <WhatsAppIcon aria-hidden="true" />
          </div>
        </Link>
      </Portal>
    </>}

  </>);
};

export default BtnFlotanteWhatsapp;
